<template>
  <img :src="this.GLOBAL.basePhotoPath+data"
       v-if="data!=null && data!=''"
      width="40" height="40" align="center"/>
</template>

<script>

    export default {
        name: "TableImg",
        props:{
          data:{}
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/command/TableImg.vue